// extracted by mini-css-extract-plugin
export default {"editorTitle":"_1sZgD3aZxCbBfxO_hIuUll","marTop20":"YvdPRkJmgFi-1MnxUd5cp"};